var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSlidersSimple = function SvgSlidersSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.9 12h2.4V9.6H2.9zm3.2-.8v1.6h-4v-4h4v1.6h8.8v.8H6.1M2.5 5.6h-.4v-.8h8.8V3.2h4v4h-4V5.6zM11.7 4v2.4h2.4V4z"
  })));
};
export default SvgSlidersSimple;